const processingLabel = document.body?.dataset.authProcessingLabel || 'Processing';

const initPasswordToggles = () => {
    document.querySelectorAll('[data-password-toggle]').forEach((button) => {
        button.addEventListener('click', () => {
            const field = document.getElementById(button.dataset.passwordToggle);

            if (!field) {
                return;
            }

            const nextType = field.type === 'password' ? 'text' : 'password';
            field.type = nextType;
            button.setAttribute('aria-pressed', String(nextType === 'text'));

            button.querySelectorAll('[data-password-icon]').forEach((icon) => {
                icon.hidden = icon.dataset.passwordIcon !== nextType;
            });
        });
    });
};

const initSubmitState = () => {
    document.querySelectorAll('.auth-shell form').forEach((form) => {
        form.addEventListener('submit', () => {
            const button = form.querySelector('button[type="submit"], input[type="submit"]');

            if (!button || button.disabled) {
                return;
            }

            const label = button.dataset.loadingLabel || button.textContent?.trim() || processingLabel;

            button.disabled = true;
            button.classList.add('is-loading');
            button.setAttribute('aria-busy', 'true');

            if (button.tagName === 'BUTTON') {
                button.innerHTML = `
                    <span class="auth-submit__spinner" aria-hidden="true"></span>
                    <span>${label}...</span>
                `;

                return;
            }

            button.value = `${label}...`;
        }, { once: true });
    });
};

initPasswordToggles();
initSubmitState();
